module.exports = __webpack_public_path__ + "static/media/calendar.f8fe3133.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/calendar.png
// module id = 37
// module chunks = 0